/**
 * O modo da liquidação em uma letra: T (liquida o título), P (mantém aberto) ou A (amortiza as
 * parcelas da operação). `undefined` conta como total, igual ao `modeOf`.
 *
 * PL (AF-4139) toma o lugar dos três quando o pagamento chegou com o título já liquidado: o valor
 * vai para o coletor de pagamento a maior, e não para o título.
 */
import { modeOf } from '../../pages/billing/constants/liquidationModes';

const BADGE_CLASS = 'inline-block min-w-[1.25rem] px-1.5 py-0.5 rounded text-[10px] font-semibold text-white';

export const totalPartialBadge = (totalPayment: boolean | null | undefined, postSettlement = false) => {
    if (postSettlement) {
        return {
            text: 'PL', color: 'bg-pay-over',
            title: 'Pagamento pós liquidação: o título já estava liquidado, e o valor vai para o pagamento a maior',
        };
    }
    const mode = modeOf(totalPayment);
    if (mode === 'TOTAL') return { text: 'T', color: 'bg-green-500', title: 'Pagamento total' };
    if (mode === 'PARTIAL') return { text: 'P', color: 'bg-pay-partial', title: 'Pagamento parcial' };
    return { text: 'A', color: 'bg-[#7c3aed]', title: 'Amortização de parcelas' };
};

const TotalPartialBadge: React.FC<{ totalPayment: boolean | null | undefined; postSettlement?: boolean }> = ({
    totalPayment, postSettlement = false,
}) => {
    const badge = totalPartialBadge(totalPayment, postSettlement);
    return <span className={`${BADGE_CLASS} ${badge.color}`} title={badge.title}>{badge.text}</span>;
};

export default TotalPartialBadge;
